import { render, staticRenderFns } from "./HistoryNav.vue?vue&type=template&id=43b45cb8&"
import script from "./HistoryNav.vue?vue&type=script&lang=js&"
export * from "./HistoryNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports